import * as React from "react"
import {Collection} from "../Todoist/Main";
import {TaskInterface} from "../Todoist/Task";
import {ReactTask, ReactTaskStat} from "./ReactTask";
import * as Tl from "../Todoist/TimeLine";
import {TimeSlot} from "../Todoist/TimeLine";
import Timeout = NodeJS.Timeout;


export class TimeLine extends React.Component<{ tasks: Collection<TaskInterface> }, { tasks: Collection<TaskInterface> }> {

    private scale = 1.2; // масшаб временной линии
    private dayStart = 420; // начала дня
    private taskTimeLag = 5;// 5 минут до начала задачи без даты

    constructor(public props: { tasks: Collection<TaskInterface> }) {


        super(props);
        this.state = {
            tasks: this.props.tasks

        };

    }


    componentWillMount(): void {
        this.handgleOnChangeDate(new Date());
    }


    createTimeLine(): React.ReactElement[] {

        let timesBlocks = [];

        for (let i = 0; i <= 23; i++) {

            timesBlocks.push(<div key={i}
                                  style={{
                                      "height": this.toScale(60) + "px"

                                  }}
                                  className={"time-line__time-block"}>{i}:00</div>);

        }

        return timesBlocks;


    }

    handgleOnChangeDate(date: Date) {

        //  this.state.tasks = new


        let items = this.props.tasks.filter((item) => {
            if (!item.hasDate()) {
                return false;

            }

            let compare = function (date: Date) {
                return date.toLocaleString('default', {day: "numeric", month: "numeric", year: "numeric"});
            };
            return compare(item.getDueDate()) == compare(date);
        });

        this.setState({tasks: items})

    }

    createDays(): React.ReactElement[] {

        let timesBlocks = [];

        for (let i = 0; i <= 7; i++) {
            let date = new Date();
            date.setDate(date.getDate() + i);

            timesBlocks.push(<a style={{margin: 10}} href={"#"} onClick={() => this.handgleOnChangeDate(date)}
                                key={i}>{date.toLocaleString('default', {
                day: "numeric",
                month: "numeric",
                year: "numeric"
            })}</a>);

        }

        return timesBlocks;


    }

    getScale() {
        return this.scale;
    }

    toScaleFont() {

        return this.scale * 0.8;

    }

    toScale(minute: number) {
        return this.scale * minute;

    }

    render(): React.ReactElement<any, string | React.JSXElementConstructor<any>> | string | number | {} | React.ReactNodeArray | React.ReactPortal | boolean | null | undefined {

        return (

            <div className={"row"} style={{fontSize: this.toScaleFont() + "em"}}>

                <div className={"col-lg-12"}>
                    {this.createDays()}
                    <div>
                        <ReactTaskStat tasks={this.state.tasks}/>

                    </div>
                </div>

                <div className={"col-lg-12"}>

                    <BurningTime coefficient={this.getScale()}/>

                    <div className={"row position-relative"}>
                        <div className={"col-lg-1 col-xs-1"}>
                            <TimeLineBlock toScale={this.toScale.bind(this)}/>
                        </div>
                        <div className={"col-lg-11 col-xs-11"}>


                            <DayLine tasks={this.state.tasks} toScale={this.toScale.bind(this)}/>


                            {/*<div style={{"height":"120px", "top": "480px", "background":"green","position":"relative"}}>I am task</div>*/}
                        </div>
                    </div>
                </div>
            </div>

        )
            ;
    }

}

class TimeLineBlock extends React.Component {

    public props: { toScale: (num: number) => number };

    render(): React.ReactElement<any, string | React.JSXElementConstructor<any>> | string | number | {} | React.ReactNodeArray | React.ReactPortal | boolean | null | undefined {
        let timesBlocks = [];

        for (let i = 0; i <= 23; i++) {

            timesBlocks.push(<div key={i}
                                  style={{
                                      "height": this.props.toScale(60) + "px"

                                  }}
                                  className={"time-line__time-block"}>{i}:00</div>);

        }

        return timesBlocks;
    }

}


class BurningTime extends React.Component<{ coefficient: number }, { top: number, date: Date }> {

    private interval: Timeout;

    constructor(props?: { coefficient: number }) {
        super(props);

        this.state = {
            top: this.calculateTop(),
            date: new Date()
        }
    }

    componentDidMount(): void {

        this.interval = setInterval(() => this.setState({top: this.calculateTop(), date: new Date()}), 1000 * 25);

    }

    componentWillUnmount(): void {
        clearInterval(this.interval);
    }

    calculateTop() {
        let date = new Date();
        return (date.getHours() * 60 + date.getMinutes() + date.getSeconds() / 60) * this.props.coefficient;
    }


    render(): React.ReactElement<any, string | React.JSXElementConstructor<any>> | string | number | {} | React.ReactNodeArray | React.ReactPortal | boolean | null | undefined {
        return (
            <div className={"burning-line"}>
                <div className={"burning-time"} style={{height: this.state.top}}>
                    <div className={"burning-time__block"}></div>

                </div>
                <div className={"burning-time__line"} style={{top: this.state.top}}>
                    <div
                        className={"burning-time__time burning-time__time_left"}>{this.state.date.toLocaleString('default', {
                        hour: "numeric",
                        minute: "numeric"
                    })}</div>

                </div>
            </div>
        );
    }
}

class DayLine extends React.Component<{ tasks: Collection<TaskInterface>, toScale: ((minute: number) => number) }> {


    private dayStart = 420; // начала дня

    createTimeLineTaskCollection(): Collection<Tl.TimeLineTask> {
        let toDay = new Date();
        let timeDateStart = (toDay.getHours() * 60 + toDay.getMinutes()) > this.dayStart ? (toDay.getHours() * 60 + toDay.getMinutes()) : this.dayStart;
        let slot = [
            new TimeSlot({start: 660, end: 705}),
            new TimeSlot({start: 0, end: timeDateStart}),
            new TimeSlot({start: 1320, end: 1440})
        ];

        let timeLine = new Tl.TimeLine(this.props.tasks, slot);
        return timeLine.getTasks();

    }

    render(): React.ReactElement<any, string | React.JSXElementConstructor<any>> | string | number | {} | React.ReactNodeArray | React.ReactPortal | boolean | null | undefined {
        return (
            <div className={"time-line__task-list"}>
                {this.createTimeLineTaskCollection().getItems().map((task) => {

                        return <div key={task.getTask().getId()} className={"time-line__task-wrap"} style={{
                            height: this.props.toScale(task.height()),
                            top: this.props.toScale((task.startAt())),
                            width: task.getWidth() + "%",
                            marginLeft: task.getMarginLEft() + '%',
                        }}>
                            {/*<div style={{position:"absolute"}}>{task.startAt()} {task.endAt()}, CRoss: {task.getCrossing().getCount()}</div>*/}

                            <ReactTask key={task.getTask().getId()} task={task.getTask()}/>

                        </div>
                    }
                )}
            </div>
        );
    }


}


export class Week extends React.Component {

    private tasks: Collection<TaskInterface>;
    private scale = 1.2; // масшаб временной линии
    private weekday = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

    constructor(public props: { tasks: Collection<TaskInterface> }) {


        super(props);
        this.tasks = props.tasks;


    }

    toScale(minute: number) {
        return this.scale * minute;

    }

    dateFilter(date: Date) {

        let items = this.props.tasks.filter((item) => {
            if (!item.hasDate()) {
                return false;

            }

            let compare = function (date: Date) {
                return date.toLocaleString('default', {day: "numeric", month: "numeric", year: "numeric"});
            };
            return compare(item.getDueDate()) == compare(date);
        });
        console.log((date));

        return items;

    }

    render(): React.ReactElement<any, string | React.JSXElementConstructor<any>> | string | number | {} | React.ReactNodeArray | React.ReactPortal | boolean | null | undefined {

        let cells = [];
        let dayHeader = [];
        let date = new Date();

        for (let i = 0; i <= 6; i++) {
            let dateNext = new Date();
            dateNext.setDate(date.getDate() + i);
            dayHeader.push(<div className={"week-day"}><h2>{this.weekday[dateNext.getDay()]}</h2>
                <div className={"week-day_statistic"}><ReactTaskStat key={i} tasks={this.dateFilter(dateNext)}/></div></div>)

            cells.push(<div className={"week-day"}>
                <DayLine key={i} tasks={this.dateFilter(dateNext)} toScale={this.toScale.bind(this)}/>
            </div>);
        }
        return <div className={"week"}>
           <div className={"row"}>

               <div className={"col-xs-11 col-xs-offset-1"}>
                   {dayHeader}
               </div>

           </div>
            <div className={"row"}>
            <div className={"col-lg-1 col-xs-1"}>
                <TimeLineBlock toScale={this.toScale.bind(this)}/>
            </div>
            <div className={"col-lg-11 col-xs-11"}>
                {cells}
            </div>
            </div>
        </div>
            ;
    }

}





